// components/admin-dashboard/charts/ChartCard.js
import React from 'react';
import { RefreshCcw } from "lucide-react";
import PropTypes from 'prop-types';

const ShimmerEffect = ({ className }) => (
  <div className={`animate-pulse bg-gray-200 ${className}`} />
);

export const ChartCard = ({ 
  title, 
  children, 
  icon: Icon, 
  isLoading = false, 
  error = null,
  className = '',
  color = '#003087',
  height = '300px'
}) => {
  const containerClasses = `bg-white rounded-lg shadow p-6 ${className}`.trim();
  
  const renderContent = () => {
    if (error) {
      return (
        <div className="flex flex-col items-center justify-center h-[300px] text-center">
          <p className="text-red-500 mb-2">Error loading chart</p>
          <p className="text-sm text-gray-500">{error}</p>
        </div>
      );
    }

    if (isLoading) {
      return <ShimmerEffect className={`h-[${height}] rounded`} />;
    }

    return children;
  };

  return (
    <div className={containerClasses}>
      <div className="flex justify-between items-center mb-6">
        <div className="flex items-center space-x-2">
          {Icon && <Icon className="h-5 w-5" style={{ color }} />}
          {title && <h2 className="text-lg font-medium">{title}</h2>}
        </div>
        {isLoading && <RefreshCcw className="h-5 w-5 animate-spin text-gray-400" />}
      </div>
      {renderContent()}
    </div>
  );
};

ChartCard.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
  icon: PropTypes.elementType,
  isLoading: PropTypes.bool,
  error: PropTypes.string,
  className: PropTypes.string,
  color: PropTypes.string,
  height: PropTypes.string
};

export default ChartCard;